import { faCog } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { useTranslation } from 'next-i18next';
import { Meetingroom } from '../../../interfaces/interfaces';
import VyTooltip from '../../common/VyTooltip';
import { MeetingroomDetailsModal } from './MeetingroomDetailsModal';

interface MeetingDetailsButtonProps {
  meeting: Meetingroom;
}

export const MeetingDetailsButton = (props: MeetingDetailsButtonProps) => {
  const { meeting } = props;

  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <VyTooltip title={t('account:meetingroom-config.tooltip')}>
        <FontAwesomeIcon
          style={{ marginLeft: '0.5rem', marginRight: '0.5rem' }}
          icon={faCog}
          className="cursor-pointer"
          color="white"
          onClick={() => setOpen(true)}
        />
      </VyTooltip>
      {open && <MeetingroomDetailsModal open={open} meeting={meeting} onClose={() => setOpen(false)} />}
    </>
  );
};
